/*
 * Company Page
 */

(function () {
	var bioTimeout,
		lastIndex;

	$('.toggle-slide2').on( 'click', '.toggle-slide__item', function() {

		clearTimeout(bioTimeout);

		var click = $(this),
			index,
			content,
			limit,
			columns,
			selector,
			destinationRow,
			lastRow,
			destinationElement,
			animationSpeed = 350,
			timeOutDuration = 0;

		if ($('.toggle-slide__open').length > 0) {
			timeOutDuration = animationSpeed;

			$('.toggle-slide__open').slideToggle(animationSpeed);
		}

		click.siblings('.active').find('.btn-toggle').removeClass('btn-toggle--open');
		click.siblings('.active').removeClass('active');

		bioTimeout = setTimeout(function() {

			$('.toggle-slide__open').remove();

			if (click.hasClass('active')) {
				click.removeClass('active');
				click.find('.btn-toggle').removeClass('btn-toggle--open');
			} else {
				click.addClass('active');
				click.find('.btn-toggle').addClass('btn-toggle--open');

				$('html, body').animate({
			        scrollTop: click.offset().top
			    }, 200);
			}

			index = click.index() + 1;

			if (index === lastIndex) {
				lastIndex = 0;
				return;
			}

			content = click.find('.toggle-slide__content').html();
			limit = $('.toggle-slide__item').length;

			if (window.innerWidth > 1024) {
				columns = 6;
			} else if (window.innerWidth > 768) {
				columns = 4;
			} else if (window.innerWidth > 600) {
				columns = 3;
			} else {
				columns = 2;
			}

			destinationRow = Math.ceil(index / columns);
			lastRow = Math.ceil(limit / columns);

			if (destinationRow !== lastRow) {
				destinationElement = Math.ceil(index / columns) * columns;
			} else {
				destinationElement = limit;
			}

			selector = $('.toggle-slide__item:nth-child(' + destinationElement + ')');
			selector.after('<li class="toggle-slide__open">' + content + '</li>');
			$('.toggle-slide__open').slideToggle(animationSpeed);

			lastIndex = index;

		}, timeOutDuration);

	});
})();